import Head from 'next/head';
import { defaultMeta } from './meta.const';

export * from './meta.const';

export interface MetaProps {
  title?: string;
  description?: string;
  image?: string;
  canonicalHref?: string;
}

export default function PageMeta({
  title,
  description,
  image,
  canonicalHref,
}: MetaProps) {
  return (
    <Head>
      <title>{title || defaultMeta.title}</title>
      <meta
        name="description"
        content={description || defaultMeta.description}
        key="description"
      />

      <meta
        name="og:title"
        content={title || defaultMeta.title}
        key="og_title"
      />
      <meta
        name="og:description"
        content={description || defaultMeta.description}
        key="og_description"
      />

      <meta
        name="og:image"
        content={image || defaultMeta.image}
        key="og_image"
      />

      <link rel="canonical" href={canonicalHref || defaultMeta.canonicalHref} />
    </Head>
  );
}
